const messages = {
  overview: {
    period: 'Period',
    monthsCurrent: 'Current month',
    monthsLast: 'Last month',
    months3: '3 months',
    months6: '6 months',
    months12: '12 months',
    deltaFlat: '▬ no change',
    deltaVsPrev: 'vs. previous period',
    kpiCredits: 'Credits consumed',
    kpiMessages: 'Messages',
    kpiAvgPerMsg: 'Credits / message',
    kpiCostCenters: 'Active cost centers',
    chartTitle: 'Credits per month and channel',
    chartSubtitle: 'Stacked by channel',
    credits: 'credits',
    messages: 'messages',
    byChannelTitle: 'By channel',
    byChannelSubtitle: 'Credits and messages for the period',
    topCentersTitle: 'Top cost centers',
    topCentersSubtitle: 'By credits consumed in the period',
    colChannel: 'Channel',
    colMessages: 'Messages',
    colCredits: 'Credits',
    colAvg: 'Credits/msg',
    colCostCenter: 'Cost center',
    colShare: 'Share',
  },
  name: 'Credit Event Summary |||| Credit Event Summaries',
  fields: {
    costCenterName: 'Cost Center',
    applicationName: 'Application',
    channel: 'Channel',
    year: 'Year',
    month: 'Month',
    totalMessages: 'Total Messages',
    totalCreditsConsumed: 'Total Credits Consumed',
    createdAt: 'Created Date',
  },
  empty: 'No event summaries yet',
  filters: {
    costCenterName: 'Cost Center',
    applicationName: 'Application',
    channel: 'Channel',
  },
  search: {
    placeholder: 'Search Credit Summary',
  },
  trendsTitle: 'Credit & Message Usage by Channel per Cost Center + Application',
  trendsXAxisLabel: 'Cost Center - Application',
  trendsYAxisLabel: 'Total Count',
  trendsEmpty: 'No trend data available',
  trendsFailed: 'Failed to load trend data',
};

export default messages;
